import { useContext } from 'react'
import { GlobalDataContext, TemplateContext, evaluateTemplateValue } from '@ea-lab/reactive-json'
import { BuilderShell } from './BuilderShell'

/**
 * Élément reactive-json qui monte UNE page du builder (hôte `dashboard`) en
 * lecture seule, à l'endroit où le YAML le demande.
 *
 * POURQUOI DU REACT ICI (rituel config-first) : aucun rjBuild ne peut héberger
 * une page du builder — sa disposition n'est pas du YAML mais un blob
 * `field_layout` que seul le couple BuilderProvider/BuilderCanvas sait charger,
 * résoudre contre le registre des blocs et monter (chaque bloc étant lui-même un
 * ReactiveJsonRoot). Ce composant n'ajoute AUCUNE logique : il ne fait que
 * traduire une valeur du store (l'identifiant de page) en point de montage. Tout
 * le reste de l'écran d'accueil — salutation, choix de la page, états vides —
 * reste du YAML.
 *
 * `id` accepte le nid ou le slug portable. Vide/0 → ne rend rien : c'est au YAML
 * d'afficher son état vide (`hide` sur `~~.home.id`), pas à ce composant.
 *
 * Enregistré dans [App.jsx](../../App.jsx) sous `customPlugins.element`.
 */
export function DashboardMount({ props = {} }) {
  const globalDataContext = useContext(GlobalDataContext)
  const templateContext = useContext(TemplateContext)

  let id
  try {
    id = evaluateTemplateValue({ valueToEvaluate: props.id, globalDataContext, templateContext })
  }
  catch {
    id = undefined
  }
  if (id === undefined || id === null || id === '' || id === 0 || id === '0') return null

  // `showBar: false` : la barre du builder (nom + « Éditer ») ferait doublon
  // avec l'en-tête de l'accueil, qui porte déjà le titre, le sélecteur de page
  // et le lien d'édition.
  return <BuilderShell hostKind="dashboard" hostId={String(id)} readOnly embedded showBar={false} />
}

export default DashboardMount
